// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:21
import { User_abstract } from './../abstract/SagaBase/User_abstract';
export class User extends User_abstract {}
